import { render, staticRenderFns } from "./AsignacionMasiva.vue?vue&type=template&id=fbcca1d4&"
import script from "./AsignacionMasiva.vue?vue&type=script&lang=js&"
export * from "./AsignacionMasiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports